import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-solid-svg-icons';
import { Client } from '../../../../context/ClientContext';
import { MediaFile } from './mediaUtils';
import MediaGridItem from './MediaGridItem';

interface MediaGridProps {
  mediaFiles: MediaFile[];
  isLoading: boolean;
  onPreview: (file: MediaFile) => void;
  onMediaAdded: () => void;
  onError: (message: string) => void;
  onSuccess: (message: string) => void;
  client?: Client;
}

export default function MediaGrid({
  mediaFiles,
  isLoading,
  onPreview,
  onMediaAdded,
  onError,
  onSuccess,
  client,
}: MediaGridProps) {
  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '32px 0' }}>
        <div
          className="animate-spin w-7 h-7 border-2 rounded-full"
          style={{ borderColor: 'var(--accent)', borderTopColor: 'transparent' }}
        />
      </div>
    );
  }

  if (mediaFiles.length === 0) {
    return (
      <div style={{ padding: '28px 0', textAlign: 'center', color: 'var(--text-muted)' }}>
        <FontAwesomeIcon icon={faImage} style={{ fontSize: '22px', color: 'var(--text-faint)' }} />
        <p style={{ margin: '12px 0 4px', fontSize: 'var(--text-base)' }}>No media yet</p>
        <p style={{ margin: 0, fontSize: 'var(--text-xs)', color: 'var(--text-faint)' }}>
          Files shared with this client will appear here.
        </p>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'grid',
        // 190px tiles, but never more than half the row: a phone gets two across instead of one full-width tile
        gridTemplateColumns: 'repeat(auto-fill, minmax(min(190px, calc(50% - var(--space-3) / 2)), 1fr))',
        gap: 'var(--space-3)',
      }}
    >
      {mediaFiles.map((file) => (
        <MediaGridItem
          key={file.id}
          file={file}
          client={client}
          onPreview={onPreview}
          onMediaAdded={onMediaAdded}
          onError={onError}
          onSuccess={onSuccess}
        />
      ))}
    </div>
  );
}
